<template>
    <section>
        <vue-headful
            title="TZ Design Box - Upload Price"
            description="TZ Design Box"
        />

        <div class="columns">
            <div class="column is-2 menu-vert">
                <MenuVert :currentactive="'catalog-i18n'" />
            </div>
            <div class="column is-10" style="margin-top:25px;">
                <div v-if="article !== null">
                    <tr-title-bar
                        :translatedTrUnits="translatedTrUnits"
                        :totalTrUnits="totalTrUnits"
                        @move-tr="selectTr($event)"
                        v-if="article"
                    >
                        Article {{ article.model }} Translation
                    </tr-title-bar>
                    <!--<b-button @click="dump">Dump</b-button>-->
                    <nav class="breadcrumb" aria-label="breadcrumbs">
                        <ul>
                            <li v-for="(p, idx) in article.catalog_path" :key="idx">
                                <router-link :to="p.url">
                                    <tr-display v-bind="p.props.label"></tr-display>
                                </router-link>
                            </li>
                        </ul>
                    </nav>
                    <ul>
                        <li>Article Name Short <tr-text v-bind="article.props.art_info_short"
                                :tracker="tracker"
                                @edit-tr="editTranslation"
                            > </tr-text>
                        </li>
                        <li v-if="article.props.art_info_long" >Article Name <tr-text v-bind="article.props.art_info_long"
                                :tracker="tracker"
                                @edit-tr="editTranslation"
                            > </tr-text>
                        </li>
                    </ul>
                    <div :is="child.tag" v-for="(child, idx) in article.widgets" :key="idx"
                        v-bind="child"
                        :index="idx"
                        :tracker="tracker"
                        @edit-tr="editTranslation"
                    ></div>
                    <component :is="child.tag" v-for="(child, idx) in article.logic" :key="100000 + idx"
                        v-bind="child"
                        :index="idx"
                        :tracker="tracker"
                        @edit-tr="editTranslation"
                    ></component>
                    <tr-edit
                        :trackerIdx="currentTrackerIdx"
                        :tid="currentTid"
                        :translatedTrUnits="translatedTrUnits"
                        :totalTrUnits="totalTrUnits"
                        @move-tr="selectTr($event)"
                        @close="closeTrEdit"
                    />
                    </div>
                    <b-loading :active.sync="loading"></b-loading>
                </div>
        </div>
    </section>
</template>

<script>
import TranslationBaseView  from "@/views/TranslationBaseView"
import I18nParafolder       from "@/components/i18n/I18nParafolder"
import I18nLogicCommand     from "@/components/i18n/I18nLogicCommand"
import I18nMessagebox       from "@/components/i18n/I18nMessagebox"
import TrDisplay            from "@/components/translation/TrDisplay"
import { mapState }         from 'vuex'
import axios from 'axios'

export default {
    name: "ArticleView",
    components: {I18nParafolder, I18nLogicCommand, I18nMessagebox, TrDisplay},
    extends: TranslationBaseView,
    data () {
        return {
            currentTrackerIdx: null,
            currentTid: null,
            tracker:    []
        }
    },
    computed: {
        ...mapState("translation", { article: state => state.article}),
        loading () { return this.article === null},
    },
    methods: {
        _clearRoot () {
            this.$store.commit ("translation/genericSet", {key : "article", data: null})
        },
        _updateRoot ({id, path}) {
            const model =path.split ("/").splice (-1) [0]
            this.$store.dispatch ("translation/loadArticle", {id, model, self: this})
            this.isLoading = false
        },
        dump () {
            const tids = []
            for (const tru of this.uniqueTrUnits)
                if (tru.tid) tids.push (tru.tid)
            axios.post ("i18n/dump/", [tids])
        }
    },
    mounted () {
        const params = this.$route.params
        this.updateRoot (params)
    }
}
</script>

<style>

</style>